import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLPublicContactsService {
    static getMortgageeContacts(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('publiccontacts'),
            'getMortgageeContacts',
            [],
            additionalHeaders
        );
    }
}
